import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ObrasListar from '../../../components/obras/paralizadas';


function ObrasScreen () {
    return (
        <Fragment>
            <Head titulo="Obras Públicas Paralizadas"/>
            <Header />
            <Container>
                <ObrasListar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ObrasScreen;